import React, { Suspense, lazy } from "react";

const CuidadosIndividual = lazy(() => import("./cuidados_individual_filters"));
const ExecucaoSessoes = lazy(() => import("./execusao_sessoes_filters"));

interface Props {
    getFieldDecorator: any;
    selectedDashboardKey: string;
}

export function ApplyDashboardFilter({ getFieldDecorator, selectedDashboardKey }: Props) {
    return (
        <Suspense fallback={<p id="loading">Loading...</p>}>
            {selectedDashboardKey === "scl_registo_de_cuidados_individual" && (
                <CuidadosIndividual getFieldDecorator={getFieldDecorator} />
            )}
            {selectedDashboardKey === "scl_execucao_sessoes" && (
                <ExecucaoSessoes getFieldDecorator={getFieldDecorator} />
            )}
        </Suspense>
    );
}
